var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/buffer/~/isarray/index.js
// module id = ../../../../buffer/node_modules/isarray/index.js
// module chunks = 5